import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Srodstvo } from './srodstvo';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-srodstvo-update',
  templateUrl: './srodstvo-update.component.html'
})
export class SrodstvoUpdateComponent
 extends BaseUpdateComponent<Srodstvo> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Naziv', Validators.required, 'required', 'SRODSTVO.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('Naziv', Validators.maxLength(50), 'maxlength', 'SRODSTVO.NAZIV.VALIDATION.MAXLENGTH');
  }

}
